export default class ChildProofOfTimes {
    static fromData(data) {
        if (!data) {
            return;
        }

        const proofOfTimes = new ChildProofOfTimes();

        proofOfTimes.id = data.id;
        proofOfTimes.link = data.link;
        proofOfTimes.linkPreview = data.linkPreview;
        proofOfTimes.name = data.name;
        proofOfTimes.created = data.created;
        proofOfTimes.is_up_to_date = data.is_up_to_date;

        return proofOfTimes;
    }
}
